import type React from 'react';

/**
 * Selector for the element @deck.gl/react wraps the map canvas in. The id it
 * generates for an id-less <DeckGL> is `${id || 'deckgl'}-wrapper`, so giving
 * a DeckGL an `id` prop would silently break every check that uses this.
 */
export const DECK_WRAPPER_SELECTOR = '#deckgl-wrapper';

/**
 * Cancels the browser's context menu on the map surface; attach it to the
 * container that holds a <DeckGL>. deck's controller treats a right-button
 * drag as the rotate-and-tilt gesture (Ctrl+drag, one of its rotate
 * modifiers, is a context click on macOS too), but Linux and macOS browsers
 * open the menu on the mousedown, which takes the pointer before the drag
 * begins. deck's event manager listens on the events root inside the wrapper,
 * and the wrapper holds nothing else that takes input (no widgets are passed,
 * so its widgets root stays empty), so cancelling throughout the wrapper is
 * exactly deck's gesture surface. Panels and buttons that are DOM siblings of
 * the wrapper keep their menu.
 */
export function suppressMapContextMenu(event: React.MouseEvent<HTMLElement>): void {
  const { target } = event;
  if (target instanceof Element && target.closest(DECK_WRAPPER_SELECTOR) != null) {
    event.preventDefault();
  }
}
